import { render } from "./ReturnClaimRequestRia.vue?vue&type=template&id=781efed1&scoped=true"
import script from "./ReturnClaimRequestRia.vue?vue&type=script&lang=js"
export * from "./ReturnClaimRequestRia.vue?vue&type=script&lang=js"

import "./ReturnClaimRequestRia.vue?vue&type=style&index=0&id=781efed1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781efed1"]])

export default __exports__